import { useEffect, useState } from 'react';
import PredpisZbierky from '../../../model/PredpisZbierky';
import { ClientStatus } from '../../../model/types/ClientStatus';
import { useClient } from '../../../context/ClientStatusContext';
import { fetchPredpisZbierkyList } from '../../../client/external/indexer/predpisZbierkyListClient';

interface ReturnType {
  predpisZbierkyList: PredpisZbierky[];
  predpisZbierkyListStatus: ClientStatus;
}

export default (
  dopyt: string,
  limit: number,
): ReturnType => {
  const [, setAction] = useState(0);
  const { wrapClient, status, data } = useClient(fetchPredpisZbierkyList);

  useEffect(() => {
    setAction(prevState => {
      clearTimeout(prevState);
      return prevState;
    });

    const act = setTimeout(async () => {
      await wrapClient(dopyt, limit);
    }, 300);

    // @ts-ignore
    setAction(act);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dopyt, limit]);

  return <ReturnType> {
    predpisZbierkyList: data || [],
    predpisZbierkyListStatus: status,
  };
};
